module.exports = __webpack_public_path__ + "img/line-thick.64371c10.svg";